import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { ClassNameMap } from '@mui/styles';
import classnames from 'classnames';
import { NOTE_LIST_ITEM_HEIGHT } from '../NoteListItem';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: theme.spacing(3.5),
    height: theme.spacing(NOTE_LIST_ITEM_HEIGHT),
    width: theme.spacing(3.5),
    padding: theme.spacing(0),
    margin: theme.spacing(0, 1.125, 0, 0)
  },
  row: {
    display: 'flex',
    height: '50%',
    width: '100%'
  },
  leftItem: {
    width: theme.spacing(1.375),
    boxSizing: 'content-box'
  },
  rightTopItem: {
    width: theme.spacing(1.375),
    borderLeft: `${theme.spacing(0.25)} solid ${
      theme.palette.groupBy.groupingTreeColor
    }`,
    borderBottom: `${theme.spacing(0.25)} solid ${
      theme.palette.groupBy.groupingTreeColor
    }`,
    boxSizing: 'content-box'
  },
  rightBottomItem: {
    width: theme.spacing(1.375),
    borderLeft: `${theme.spacing(0.25)} solid ${
      theme.palette.groupBy.groupingTreeColor
    }`,
    boxSizing: 'content-box'
  }
}));

type GroupingTreeProps = {
  classes: ClassNameMap;
};

export const GroupingTree: React.FC<GroupingTreeProps> = ({
  classes: parentClasses
}: GroupingTreeProps) => {
  const classes = useStyles();
  return (
    <div className={classnames(classes.root)}>
      <div className={classes.row}>
        <div className={classes.leftItem}></div>
        <div className={classes.rightTopItem}></div>
      </div>
      <div className={classes.row}>
        <div className={classes.leftItem}></div>
        <div
          className={classnames(
            classes.rightBottomItem,
            parentClasses.groupingTreeLastChild
          )}
        ></div>
      </div>
    </div>
  );
};
